import { useFetchListData } from '@/composables'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import type { MTServer } from './types'

const useServerStore = defineStore('server', () => {
  const { data, loading, fetchData } = useFetchListData<MTServer[]>({
    url: '/api/exchange/serverlist',
    autoFetch: false,
    showErrorMessage: false,
  })

  const serverOptions = computed(() => {
    if (!data.value) return []
    return data.value.map((item) => ({ label: item.mt_name, value: item.id }))
  })

  const reset = () => {
    loading.value = false
    data.value = null
    _initPromise = null
  }

  // Idempotent initializer (single-flight)
  let _initPromise: Promise<void> | null = null
  const init = async () => {
    if (_initPromise) return _initPromise
    _initPromise = (async () => {
      if (Array.isArray(data.value) && data.value.length > 0) return
      await fetchData()
    })()
    return _initPromise
  }

  return {
    loading,
    data,
    serverOptions,
    reset,
    init,
    fetchData,
  }
})

export default useServerStore
